import { cloneElement, memo } from 'react';
import { Box, Button, Paper, Typography } from '@mui/material';
import { DEMAND_OVERVIEW_TONE_STYLES } from '../enums/demandOverview';

const DemandMetricGroup = memo(function DemandMetricGroup({ group, onOpen }) {
  const tone = DEMAND_OVERVIEW_TONE_STYLES[group.tone] ?? DEMAND_OVERVIEW_TONE_STYLES.success;

  const renderGroupIcon = () => {
    if (group.icon) {
      return cloneElement(group.icon, {
        sx: {
          color: tone.color,
          fontSize: 30,
        },
      });
    }
  };

  return (
    <Paper
      elevation={1}
      sx={{
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        p: 1,
        borderRadius: 2,
        minWidth: 60,
      }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: 1,
        }}>
        {renderGroupIcon()}
        <Typography
          component="span"
          sx={{ color: 'text.primary', fontWeight: 500 }}>
          {group.title}
        </Typography>
      </Box>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: `repeat(${group.metrics.length}, minmax(72px, 1fr))`,
          width: '100%',
        }}>
        {group.metrics.map((metric, index) => {
          const isDisabled = metric.value === 0;

          return (
            <Button
              key={metric.id}
              disabled={isDisabled}
              onClick={() => onOpen(metric)}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minWidth: 0,
                textAlign: 'center',
                p: 0.5,
                borderRadius: 0,
                ...(index > 0 && {
                  borderLeft: '1px solid',
                  borderColor: 'divider',
                }),
                '&.Mui-disabled': {
                  color: '#8a8f98',
                },
              }}>
              <Typography
                variant="h6"
                sx={{ textAlign: 'left', fontWeight: 'bold' }}>
                {metric.value}
              </Typography>
              <Typography
                sx={{ textTransform: 'capitalize' }}
                variant="caption">
                {metric.label}
              </Typography>
            </Button>
          );
        })}
      </Box>
    </Paper>
  );
});

export default DemandMetricGroup;
